import {useParams} from 'react-router-dom'
import React, { useState } from 'react';

import {SJCliFareTerrainCom} from '../containers'
function SJCliFareTerrainComPage() {
    //we are inet so id is not passed
    console.log('SV*****SJCliFareTerrainComPage  fare))))***')
    let { id } = useParams();
    let svparams = { 'id': id}
    console.log('SVCLI fare)))****')
    console.log('SV**WE  fareCHANGE ***SJCliFareTerrainComPage',svparams)
    
    return (
        <SJCliFareTerrainCom svparams={svparams} ></SJCliFareTerrainCom>
        
    );
}
export default SJCliFareTerrainComPage